import { gql } from '@apollo/client';

/**
 * DeviceCapability fragment — Phase A matrix resolved fields.
 *
 * Adds:
 *   - classification   (normalized DeviceClassification shape)
 *   - availableCommands (catalog ids resolved per-device by open-api)
 *   - reportedCapabilities (device-reported, nullable)
 *
 * IMPORTANT: This fragment spreads cleanly into **mutation responses** and
 * **staff queries** (no projection-extract backend logic). It will NOT work
 * inside `DEVICES_QUERY` or `GET_DEVICE_DETAIL_QUERY` because those queries
 * are served by a resolver that builds MongoDB projections from the literal
 * field selection set — fragment spreads project only `{_id: 1, FragmentName: 1}`,
 * which returns empty objects. For those queries the capability fields are
 * inlined directly.
 *
 * See docs/specs/19-optiedge-mdm/04-mdm-matrix-spec.md §4.1 for the full
 * resolved-field shape and usage rules.
 */
export const DEVICE_CAPABILITY_FRAGMENT = gql`
  fragment DeviceCapability on Device {
    classification {
      platform
      vendor
      hardwareFamily
      managementCapability
      osVersionDisplay
      osVersionMajor
      modelCode
      manufacturerRaw
      platformRaw
    }
    availableCommands
    reportedCapabilities
  }
`;
